const paneBodyDefaultGFC = ["33%", "34%", "33%"];
const paneBodyDefaultGF = ["50%", "50%"];
const paneBodyDefaultFC = ["50%", "50%"];

let paneBodyGFC = paneBodyDefaultGFC;
let paneBodyGF = paneBodyDefaultGF;
let paneBodyFC = paneBodyDefaultFC;

export const setPaneBodyGFC = (value) => {
  paneBodyGF = paneBodyDefaultGF;
  paneBodyFC = paneBodyDefaultFC;

  paneBodyGFC = value;
};

export const getPaneBodyGFC = () => {
  paneBodyGF = paneBodyDefaultGF;
  paneBodyFC = paneBodyDefaultFC;

  return paneBodyGFC;
};

export const setPaneBodyGF = (value) => {
  paneBodyGFC = paneBodyDefaultGFC;
  paneBodyFC = paneBodyDefaultFC;

  paneBodyGF = value;
};

export const getPaneBodyGF = () => {
  paneBodyGFC = paneBodyDefaultGFC;
  paneBodyFC = paneBodyDefaultFC;

  return paneBodyGF;
};

export const setPaneBodyFC = (value) => {
  paneBodyGFC = paneBodyDefaultGFC;
  paneBodyGF = paneBodyDefaultGF;

  paneBodyFC = value;
};

export const getPaneBodyFC = () => {
  paneBodyGF = paneBodyDefaultGF;
  paneBodyGFC = paneBodyDefaultGFC;

  return paneBodyFC;
};

const paneAsideDefaultCLR = ["15%", "70%", "15%"];
const paneAsideDefaultCL = ["15%", "85%"];
const paneAsideDefaultCR = ["85%", "15%"];

let paneAsideCLR = paneAsideDefaultCLR;
let paneAsideCL = paneAsideDefaultCL;
let paneAsideCR = paneAsideDefaultCR;

export const setPaneAsideCLR = (value) => {
  paneAsideCL = paneAsideDefaultCL;
  paneAsideCR = paneAsideDefaultCR;

  paneAsideCLR = value;
};

export const getPaneAsideCLR = () => {
  paneAsideCL = paneAsideDefaultCL;
  paneAsideCR = paneAsideDefaultCR;

  return paneAsideCLR;
};

export const setPaneAsideCL = (value) => {
  paneAsideCLR = paneAsideDefaultCLR;
  paneAsideCR = paneAsideDefaultCR;

  paneAsideCL = value;
};

export const getPaneAsideCL = () => {
  paneAsideCLR = paneAsideDefaultCLR;
  paneAsideCR = paneAsideDefaultCR;

  return paneAsideCL;
};

export const setPaneAsideCR = (value) => {
  paneAsideCLR = paneAsideDefaultCLR;
  paneAsideCL = paneAsideDefaultCL;

  paneAsideCR = value;
};

export const getPaneAsideCR = () => {
  paneAsideCLR = paneAsideDefaultCLR;
  paneAsideCL = paneAsideDefaultCL;

  return paneAsideCR;
};

const paneAsideRightDefaultAH = [ "20%", "80%" ];
const paneAsideRightDefaultA = [ "85%, 15%"];
const paneAsideRightDefaultH = [ "15%", "85%"];

let paneAsideRightAH = paneAsideRightDefaultAH;
let paneAsideRightA = paneAsideRightDefaultA;
let paneAsideRightH = paneAsideRightDefaultH;

export const setPaneAsideRightAH = (value) => {
  paneAsideRightA = paneAsideRightDefaultA;
  paneAsideRightH = paneAsideRightDefaultH;

  paneAsideRightAH = value;
};

export const getPaneAsideRightAH = () => {
  paneAsideRightA = paneAsideRightDefaultA;
  paneAsideRightH = paneAsideRightDefaultH;

  return paneAsideRightAH;
};

export const setPaneAsideRightA = (value) => {
  paneAsideRightAH = paneAsideRightDefaultAH;
  paneAsideRightH = paneAsideRightDefaultH;

  paneAsideRightA = value;
};

export const getPaneAsideRightA = () => {
  paneAsideRightAH = paneAsideRightDefaultAH;
  paneAsideRightH = paneAsideRightDefaultH;

  return paneAsideRightA;
};

export const setPaneAsideRightH = (value) => {
  paneAsideRightAH = paneAsideRightDefaultAH;
  paneAsideRightA = paneAsideRightDefaultA;

  paneAsideRightH = value;
};

export const getPaneAsideRightH = () => {
  paneAsideRightAH = paneAsideRightDefaultAH;
  paneAsideRightA = paneAsideRightDefaultA;

  return paneAsideRightH;
};